module.exports = __webpack_public_path__ + "img/bid_agent-1.b4f52f69.png";